import { client } from '../client';
import { Organization, UserRoleName } from './types/UserProfile';

export interface IListOrganization {
  nodes: Organization[];
}

export const listAllOrganizations = async (userRole?: string): Promise<IListOrganization> => {
  const path =
    userRole === UserRoleName.CareAdvisor
      ? '/care_advisor/organizations'
      : userRole === UserRoleName.Collector
        ? '/collector/organizations'
        : '/admin/organizations';
  const { data } = await client.get(path);

  return data;
};
